$j(document).ready(function () {

	/** Goto Checkout confirm */
	$j('body').on('click', '[name="checkout"], [name="checkout"], [name="goto_gc"]', function () {
		if ($j('#agree_agb').is(':checked') && $j('#agree_widerruf').is(':checked')) {
			$j(this).submit();
		}
		else {
			alert("Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.");
			return false;
		}
	});
	$j('body').on('click', '[name="contact-submit"]', function () {
		if ($j('#agree_contact').is(':checked')) {
			$j(this).submit();
		}
		else {
			alert("Bitte akzeptieren Sie unsere Datenschutzhinweise, bevor Sie Ihre Nachricht absenden.");
			return false;
		}
	});

	/** Move Product-Page Price */
	if ($j(window).width() < 641) {
		$j('.product-form__info-item.price-section').appendTo('.card__section .product-meta');
	}

	// Collection-Filter

	if (window.location.href.indexOf("collections") > -1) {
		// Preis-Filter Sort Main
		var price_child = 0;

		if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(1) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(1) button").innerHTML.includes("Preis")) {
			price_child = 1;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(2) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(2) button").innerHTML.includes("Preis")) {
			price_child = 2;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(3) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(3) button").innerHTML.includes("Preis")) {
			price_child = 3;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(4) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(4) button").innerHTML.includes("Preis")) {
			price_child = 4;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(5) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(5) button").innerHTML.includes("Preis")) {
			price_child = 5;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(6) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(6) button").innerHTML.includes("Preis")) {
			price_child = 6;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(7) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(7) button").innerHTML.includes("Preis")) {
			price_child = 7;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(8) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(8) button").innerHTML.includes("Preis")) {
			price_child = 8;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(9) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(9) button").innerHTML.includes("Preis")) {
			price_child = 9;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(10) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(10) button").innerHTML.includes("Preis")) {
			price_child = 10;
		}

		if (price_child != 0) {
			var price_list_selector = ".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(" + price_child + ") ul.collection__filter-checkbox-list";

			var price_list, i, switching, b, shouldSwitch;
			price_list = document.querySelector(price_list_selector);
			switching = true;
			while (switching) {
				switching = false;
				b = price_list.getElementsByTagName("LI");
				for (i = 0; i < (b.length - 1); i++) {
					shouldSwitch = false;
					var price_label_a = b[i].lastElementChild.innerHTML;
					var price_label_a_tmp = price_label_a.split("€");
					let price_label_a_fin = parseInt(price_label_a_tmp[0]);
					var price_label_b = b[i + 1].lastElementChild.innerHTML;
					var price_label_b_tmp = price_label_b.split("€");
					let price_label_b_fin = parseInt(price_label_b_tmp[0]);
					if (price_label_a_fin > price_label_b_fin) {
						shouldSwitch = true;
						break;
					}
				}
				if (shouldSwitch) {
					b[i].parentNode.insertBefore(b[i + 1], b[i]);
					switching = true;
				}
			}
		}

		// Preis-Filter Sort Mobil Drawer
		var price_child = 0;

		if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(1) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(1) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 1;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(2) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(2) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 2;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(3) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(3) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 3;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(4) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(4) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 4;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(5) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(5) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 5;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(6) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(6) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 6;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(7) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(7) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 7;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(8) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(8) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 8;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(9) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(9) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 9;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(10) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(10) button.collection__filter-group-name").innerHTML.includes("Preis")) {
			price_child = 10;
		}

		if (price_child != 0) {
			var price_list_selector = "#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(" + price_child + ") ul.collection__filter-checkbox-list"
			var price_list, i, switching, b, shouldSwitch;
			price_list = document.querySelector(price_list_selector);
			switching = true;
			while (switching) {
				switching = false;
				b = price_list.getElementsByTagName("LI");
				for (i = 0; i < (b.length - 1); i++) {
					shouldSwitch = false;
					var price_label_a = b[i].lastElementChild.innerHTML;
					price_label_a = price_label_a.substr(0, price_label_a.length)
					var price_label_a_tmp = price_label_a.split(" ");
					let price_label_a_fin = parseInt(price_label_a_tmp[0]);
					var price_label_b = b[i + 1].lastElementChild.innerHTML;
					price_label_b = price_label_b.substr(0, price_label_b.length)
					var price_label_b_tmp = price_label_b.split(" ");
					let price_label_b_fin = parseInt(price_label_b_tmp[0]);
					if (price_label_a_fin > price_label_b_fin) {
						shouldSwitch = true;
						break;
					}
				}
				if (shouldSwitch) {
					b[i].parentNode.insertBefore(b[i + 1], b[i]);
					switching = true;
				}
			}
		}
	
		// Tassen-Filter Sort Main
		var tassen_child = 0;

		if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(1) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(1) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 1;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(2) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(2) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 2;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(3) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(3) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 3;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(4) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(4) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 4;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(5) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(5) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 5;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(6) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(6) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 6;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(7) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(7) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 7;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(8) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(8) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 8;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(9) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(9) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 9;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(10) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(10) button").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 10;
		}

		if (tassen_child != 0) {
			var price_list_selector = ".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(" + tassen_child + ") ul.collection__filter-checkbox-list";

			var price_list, i, switching, b, shouldSwitch;
			price_list = document.querySelector(price_list_selector);
			switching = true;
			while (switching) {
				switching = false;
				b = price_list.getElementsByTagName("LI");
				for (i = 0; i < (b.length - 1); i++) {
					shouldSwitch = false;
					var price_label_a = b[i].lastElementChild.innerHTML;
					var price_label_a_tmp = price_label_a.split("Tassen");
					let price_label_a_fin = parseInt(price_label_a_tmp[0]);
					var price_label_b = b[i + 1].lastElementChild.innerHTML;
					var price_label_b_tmp = price_label_b.split("Tassen");
					let price_label_b_fin = parseInt(price_label_b_tmp[0]);
					if (price_label_a_fin > price_label_b_fin) {
						shouldSwitch = true;
						break;
					}
				}
				if (shouldSwitch) {
					b[i].parentNode.insertBefore(b[i + 1], b[i]);
					switching = true;
				}
			}
		}

		// Tassen-Filter Sort Mobil Drawer
		var tassen_child = 0;

		if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(1) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(1) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 1;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(2) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(2) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 2;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(3) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(3) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 3;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(4) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(4) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 4;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(5) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(5) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 5;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(6) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(6) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 6;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(7) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(7) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 7;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(8) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(8) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 8;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(9) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(9) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 9;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(10) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(10) button.collection__filter-group-name").innerHTML.includes("Tassenanzahl")) {
			tassen_child = 10;
		}

		if (tassen_child != 0) {
			var price_list_selector = "#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(" + tassen_child + ") ul.collection__filter-checkbox-list"
			var price_list, i, switching, b, shouldSwitch;
			price_list = document.querySelector(price_list_selector);
			switching = true;
			while (switching) {
				switching = false;
				b = price_list.getElementsByTagName("LI");
				for (i = 0; i < (b.length - 1); i++) {
					shouldSwitch = false;
					var price_label_a = b[i].lastElementChild.innerHTML;
					price_label_a = price_label_a.substr(0, price_label_a.length)
					var price_label_a_tmp = price_label_a.split(" ");
					let price_label_a_fin = parseInt(price_label_a_tmp[0]);
					var price_label_b = b[i + 1].lastElementChild.innerHTML;
					price_label_b = price_label_b.substr(0, price_label_b.length)
					var price_label_b_tmp = price_label_b.split(" ");
					let price_label_b_fin = parseInt(price_label_b_tmp[0]);
					if (price_label_a_fin > price_label_b_fin) {
						shouldSwitch = true;
						break;
					}
				}
				if (shouldSwitch) {
					b[i].parentNode.insertBefore(b[i + 1], b[i]);
					switching = true;
				}
			}
		}
		
		// Füllmenge-Filter Sort Main
		var fuell_child = 0;

		if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(1) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(1) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 1;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(2) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(2) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 2;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(3) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(3) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 3;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(4) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(4) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 4;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(5) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(5) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 5;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(6) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(6) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 6;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(7) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(7) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 7;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(8) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(8) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 8;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(9) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(9) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 9;
		} else if ((document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(10) button") !== null) && document.querySelector(".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(10) button").innerHTML.includes("Füllmenge")) {
			fuell_child = 10;
		}

		if (fuell_child != 0) {
			var price_list_selector = ".card__section.card__section--tight .collection__filter-group-list .collection__filter-group:nth-child(" + fuell_child + ") ul.collection__filter-checkbox-list";

			var price_list, i, switching, b, shouldSwitch;
			price_list = document.querySelector(price_list_selector);
			switching = true;
			while (switching) {
				switching = false;
				b = price_list.getElementsByTagName("LI");
				for (i = 0; i < (b.length - 1); i++) {
					shouldSwitch = false;
					var price_label_a = b[i].lastElementChild.innerHTML;
					var price_label_a_tmp = price_label_a.split("Füllmenge");
					let price_label_a_fin = parseInt(price_label_a_tmp[0]);
					var price_label_b = b[i + 1].lastElementChild.innerHTML;
					var price_label_b_tmp = price_label_b.split("Füllmenge");
					let price_label_b_fin = parseInt(price_label_b_tmp[0]);
					if (price_label_a_fin > price_label_b_fin) {
						shouldSwitch = true;
						break;
					}
				}
				if (shouldSwitch) {
					b[i].parentNode.insertBefore(b[i + 1], b[i]);
					switching = true;
				}
			}
		}

		// Füllmenge-Filter Sort Mobil Drawer
		var fuell_child = 0;

		if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(1) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(1) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 1;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(2) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(2) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 2;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(3) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(3) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 3;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(4) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(4) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 4;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(5) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(5) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 5;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(6) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(6) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 6;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(7) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(7) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 7;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(8) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(8) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 8;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(9) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(9) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 9;
		} else if ((document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(10) button.collection__filter-group-name") !== null) && document.querySelector("#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(10) button.collection__filter-group-name").innerHTML.includes("Füllmenge")) {
			fuell_child = 10;
		}

		if (fuell_child != 0) {
			var price_list_selector = "#mobile-collection-filters .collection__filter-group-list .collection__filter-group:nth-child(" + fuell_child + ") ul.collection__filter-checkbox-list"
			var price_list, i, switching, b, shouldSwitch;
			price_list = document.querySelector(price_list_selector);
			switching = true;
			while (switching) {
				switching = false;
				b = price_list.getElementsByTagName("LI");
				for (i = 0; i < (b.length - 1); i++) {
					shouldSwitch = false;
					var price_label_a = b[i].lastElementChild.innerHTML;
					price_label_a = price_label_a.substr(0, price_label_a.length)
					var price_label_a_tmp = price_label_a.split(" ");
					let price_label_a_fin = parseInt(price_label_a_tmp[0]);
					var price_label_b = b[i + 1].lastElementChild.innerHTML;
					price_label_b = price_label_b.substr(0, price_label_b.length)
					var price_label_b_tmp = price_label_b.split(" ");
					let price_label_b_fin = parseInt(price_label_b_tmp[0]);
					if (price_label_a_fin > price_label_b_fin) {
						shouldSwitch = true;
						break;
					}
				}
				if (shouldSwitch) {
					b[i].parentNode.insertBefore(b[i + 1], b[i]);
					switching = true;
				}
			}
		}
	}































	/** Add Home-Insta-Template-Class */

	$j('.ooo-instagram-container').parent().parent().parent().parent().addClass("insta-section");

	/** Home-Produkt-Berater */

	if (window.location.pathname == '/' && window.innerWidth > 480) {
		$j(".section[data-custom-class='home-middle-slideshow'] .slideshow.slideshow--small").attr("uk-parallax", "opacity: 0,1; y: -50,0; viewport: 0.4");

		$j(".template-index #index-berater").load("pages/produkt-berater #berater", function () {

			var step = 1;
			var tags = [];

			$j("#berater .step.result.animate__animated").hide();
			
			$j("#berater #berater-subtext").append($j(".section[data-custom-class='home-kaffeeberater-sec01'] .html p.text-large-center"));

			const beraterNav = document.querySelector('#berater .berater-navigation .berater-nav');

			beraterNav.addEventListener('animationend', () => {
				$j(beraterNav).removeClass("animate__fadeInUp");
			});

			$j(beraterNav).addClass('muted');

			function showStep01() {
				$j(beraterNav).addClass('muted');

				$j("#berater .step.step02").hide();
				$j("#berater .animation-wrapper .grid-wrapper.step02").hide();
				$j("#berater div#berater-subtext").show();
				$j("#berater .step.step01").css('display', 'grid').addClass('animate__pulse');
				$j("#berater .animation-wrapper .grid-wrapper.step01").css('display', 'grid').addClass('animate__slideInRight');
				step = 1;
			};


			function showStep02() {
				$j(beraterNav).removeClass('muted');
				$j(beraterNav).addClass("animate__fadeInUp");
				$j("#berater .step.step01").hide();
				$j("#berater .animation-wrapper .grid-wrapper.step01").hide();
				$j("#berater div#berater-subtext").hide();

				$j("#berater .step.step03").hide();
				$j("#berater .animation-wrapper .grid-wrapper.step03").hide();

				$j("#berater .step.step02").css('display', 'grid').addClass('animate__pulse');
				$j("#berater .animation-wrapper .grid-wrapper.step02").css('display', 'grid').addClass('animate__slideInRight');
				step = 2;
			};

			function showStep03() {
				$j(beraterNav).removeClass('muted');
				$j(beraterNav).addClass("animate__fadeInUp");
				$j("#berater .step.step02").hide();
				$j("#berater .step.step01").hide();
				$j("#berater .animation-wrapper .grid-wrapper.step02").hide();

				$j("#berater .step.step04").hide();
				$j("#berater .animation-wrapper .grid-wrapper.step04").hide();

				$j("#berater .step.step03").css('display', 'grid').addClass('animate__pulse');
				$j("#berater .animation-wrapper .grid-wrapper.step03").css('display', 'grid').addClass('animate__slideInRight');
				step = 3;
			};

			/**
			function showStep04() {
				$j(beraterNav).removeClass('muted');
				$j(beraterNav).addClass("animate__fadeInUp");
				$j("#berater .step.step03").hide();
				$j("#berater .animation-wrapper .grid-wrapper.step03").hide();
	
				$j("#berater .step.step04").css('display', 'grid').addClass('animate__pulse');
				$j("#berater .animation-wrapper .grid-wrapper.step04").css('display', 'grid').addClass('animate__slideInRight');
				step = 4;
			};
			 */

			function showResult() {
				var urlParam = tags.join("+");
				var collectionURL = "collections/shop/" + urlParam;

				$j("#berater .step.step03").hide();
				$j("#berater .step.result").show().addClass('animate__pulse');
				$j("#berater .animation-wrapper .grid-wrapper.step03").hide();
				$j(beraterNav).hide();

				$j(".template-index #index-berater-result").load(collectionURL + " #berater-result", function () {
					$j("#berater-repeat").css('display', 'flex');
					
					if (window.innerWidth < 1000) {
						$j('html, body').animate({
							scrollTop: $j("#berater").offset().top - 140
						}, 500);
					}
					else if (window.innerWidth < 1110) {
						$j('html, body').animate({
							scrollTop: $j("#berater").offset().top - 170
						}, 500);
					} else {
						$j([document.documentElement, document.body]).animate({
							scrollTop: $j("#berater").offset().top - 200
						}, 500);
					}

				});

			};

			$j('#berater #auszeit').click(function () {
				tags.push("auszeit-suche");
				if (window.innerWidth < 390) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 180
					}, 500);
				}
				else if (window.innerWidth < 1000) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 140
					}, 500);
				}
				else if (window.innerWidth < 1110) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 170
					}, 500);
				}
				showStep02();
			});
			$j('#berater #experiment').click(function () {
				tags.push("experimentierfreude");
				if (window.innerWidth < 390) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 180
					}, 500);
				}
				else if (window.innerWidth < 1000) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 140
					}, 500);
				}
				else if (window.innerWidth < 1110) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 170
					}, 500);
				}
				showStep02();
			});
			$j('#berater #familie').click(function () {
				tags.push("familienmensch");
				if (window.innerWidth < 390) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 180
					}, 500);
				}
				else if (window.innerWidth < 1000) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 140
					}, 500);
				}
				else if (window.innerWidth < 1110) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 170
					}, 500);
				} else {
					$j([document.documentElement, document.body]).animate({
						scrollTop: $j("#berater").offset().top
					}, 500);
				}
				showStep02();
			});
			$j('#berater #beschaeftigt').click(function () {
				tags.push("vielbeschaeftigt");
				if (window.innerWidth < 390) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 180
					}, 500);
				}
				else if (window.innerWidth < 1000) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 140
					}, 500);
				}
				else if (window.innerWidth < 1110) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 170
					}, 500);
				} else {
					$j([document.documentElement, document.body]).animate({
						scrollTop: $j("#berater").offset().top
					}, 500);
				}

				showStep02();
			});
			$j('#berater #perhand').click(function () {
				tags.push("per-hand");
				if (window.innerWidth < 390) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 180
					}, 500);
				}
				else if (window.innerWidth < 1000) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 140
					}, 500);
				}
				else if (window.innerWidth < 1110) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 170
					}, 500);
				}
				showStep03();
			});
			$j('#berater #knopfdruck').click(function () {
				tags.push("knopfdruck");
				if (window.innerWidth < 390) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 180
					}, 500);
				}
				else if (window.innerWidth < 1000) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 140
					}, 500);
				}
				else if (window.innerWidth < 1110) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 170
					}, 500);
				}
				showStep03();
			});
			$j('#berater #kraeftig').click(function () {
				tags.push("kraeftig");
				showResult();
			});
			$j('#berater #mild').click(function () {
				tags.push("mild");
				showResult();
			});
			$j('#berater #klassisch').click(function () {
				tags.push("klassisch");
				showResult();
			});
			$j('#berater #neugierig').click(function () {
				tags.push("neugierig");
				showResult();
			});
			$j('#berater #anspruchsvoll').click(function () {
				tags.push("anspruchsvoll");
				showResult();
			});

			$j('#berater .berater-navigation .berater-nav').click(function () {
				tags.pop();
				if (window.innerWidth < 390) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 180
					}, 500);
				}
				else if (window.innerWidth < 1000) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 140
					}, 500);
				}
				else if (window.innerWidth < 1110) {
					$j('html, body').animate({
						scrollTop: $j("#berater").offset().top - 170
					}, 500);
				}
				if (step == 2) {
					showStep01();
				} else if (step == 3) {
					showStep02();
				} else if (step == 4) {
					showStep03();
				}
			});

			$j('#berater-repeat button').click(function () {
				tags = [];
				$j("#berater .step.result").hide();
				$j("#index-berater-result #berater-result").remove();
				$j("#berater-repeat").hide();
				showStep01();
				$j("#berater .berater-navigation .berater-nav").show();


				$j([document.documentElement, document.body]).animate({
					scrollTop: $j("#berater").offset().top - 170
				}, 500);

			});

		});
	}

	if (window.location.href.indexOf("store-locator") > -1) {
		$j('<div id="main-before"></div>').insertBefore("#main");
		$j('<div id="main-after"></div>').insertAfter("#main");
		$j("#main-before").load("/pages/haendlersuche #locator-top");
		$j("#main-after").load("/pages/haendlersuche #locator-bottom");
	}
});
